export enum MeetingType {
  AnnualMeeting = 'Annual Meeting',
  EdgeMeeting = 'Edge Meeting',
  GlobalConferenceMeeting = 'Global Conference',
  TopOfTheTableMeeting = 'Top of Table Meeting',
}
